module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "d2-d5f88a5f148ed-d1e652"
    }
  }, [_c('h2', {
    staticClass: "chapter-number "
  }, [_vm._v("FIVE")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title "
  }, [_vm._v("The Stephens brownstone")]), _vm._v(" "), _c('p', {
    staticClass: "flush-left-opener ",
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('span', {
    staticClass: "drop-cap char-drop-cap"
  }, [_vm._v("T")]), _vm._v("he news is playing at a low volume on a wall TV. Three hours after it happened, a reporter for one of the local channels is standing beside a pile of sandstone blocks at the 79th Street work site, thrusting her mic into the face of the man she’s grilling. That man, in a suit and ugly tie and wearing a hardhat, has a superimposed title running across his chest that reads, "), _c('em', [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("Joseph Gargano, Reconstruction Associates")])]), _vm._v(". He appears to be defending himself.")]), _c('span', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "indented "
  }, [_vm._v("Gary picks up the TV remote and turns off the set.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Pippa reaches for the remote, saying, ‘We were just coming to the good part, you and Army.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Gary beats her to the electronic instrument and sticks it in a drawer.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Again? You’ve seen me shaking like a leaf twice already, on nine and eleven.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘But it was a near-death experience!’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘It was an accident. I’m OK. Army’s OK. Can we get back to work?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Pippa’s phone rings. She looks at the screen. ‘Brenda. Wants to know how you are.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Tell her I’m fine.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘I’ll tell her you’re cranky.’ His sister starts typing a text with her thumbs. ‘In other words, back to your old self.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Exactly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Gary reaches into the shopping cart, now that the groceries are in the fridge, and lifts the top film can, which is nearly as big as a manhole cover, from the stack of seven. The yellow tape on the edge of the can reads, "), _c('em', [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("Project 11, #4, 5-12-69, Property WDP")])]), _vm._v(". Unrolling a random strip of film from the dozen inside, he holds it up to the light as his sister looks on.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Pippa says, ‘You’re gonna need Pop’s bin.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He picks up another strip and eyes it even as he yanks his head behind him. ‘Storage room.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Pippa comes back wheeling a canvas-sided bin with a metal frame and a row of hooks on top. She rolls it past Army in his dog bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Is it too early to ask?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Gary squints at a third short strip from Can 4. Holding it up to the light, he sees a couple of odd black shapes on a blue background. Without looking back, he says, ‘Way too early.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Then he turns to face his sister. ‘But you can ask it anyway: “What’s a bunch of half-century-old film odds and ends doing in a locker by the river?” And: “Who or what the hell is WDP?” No idea. Yet.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("She’s been studying the heavy cans in the basket. ‘Then you better start with the first one.’")]), _c('span', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "indented "
  }, [_vm._v("She hands him a can while reading aloud, ‘Project 11, #1, 4-30-69.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("An hour later, with the sandstone block to-do behind them, brother and sister are working like the well-oiled machine they once were. Gary, in white cotton gloves, runs each strip, some several yards long, others only inches, through the flatbed. On the suite’s big screen, the word ‘Record’ in red flashes at the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Then he marks the strip at one end with a grease pencil. Pippa hangs each one on a particular hook, depending on Gary’s marking, over the canvas bin by an end sprocket. There are dozens of film ‘ends’ hanging from the hooks.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Pippa talks to the back of her brother’s head as he works. ‘Ever think we’d be handling celluloid again?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Without turning around, he answers. ‘Not in a million … hey!’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Up on the screen there’s a close-up of Charlie Stephens’s thirty-ish face as he adjusts the lens of the camera shooting the film.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("A startled Pippa blurts out, ‘It’s Pop!’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("When Charlie steps aside, there’s a football field-sized soundstage behind him where dozens of stagehands are wrangling some kind of huge floor covering into place. Like the grounds crew at Citi Field wrestling a tarp on a rainy day. They lower it, looking at Charlie, who’s clearly the boss. He motions and they move it a few inches. We get glimpses of a pockmarked, painted, hard rubber tarp before the filmstrip runs out.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Gary hurriedly sets up the next strip of film to run through the KEM. It shows Charlie, his shoes swathed in cotton booties, standing on the floor covering, which looks like the surface of the moon. A camera on a large crane is off to one side.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Pippa says, ‘I don’t remember this one. Do you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Her brother, too, is puzzled. ‘For Cronkite, maybe?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He looks at his watch and gets up hurriedly. ‘Take over. I’ve got … something.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘A date?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘A drink.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘With my friend Pamela? You called her?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘She called me.’ He points to the landline on the console. ‘On that very phone.’ Then he adds, ‘It’s just a drink.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Pippa takes her brother’s place as he reaches for the leash.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘You taking Army?’")]), _c('span', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "indented "
  }, [_vm._v("He shrugs. ‘You said she’s a dog lover.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("She gives him a baleful look. ‘Give this one a shot, why don’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Gary straightens up. ‘You mean, “Stop comparing them to Carla.” I hear you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He kisses the top of her head as she runs another strip.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘I’ll be at Tumulty’s.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented-space-after "
  }, [_vm._v("Army pulls Gary toward the door as the suite’s screen shows a travel shot along the out-of-focus surface of the pockmarked moon.")]), _vm._v(" "), _c('p', {
    staticClass: "flush-left "
  }, [_vm._v("Gary and Pamela, an attractive woman of about his age, sit at a table with drinks. She stirs hers as Army lies on the floor between them. The evening news, as usual, is playing on the TV behind the bar. A little tentatively, she begins.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘I guess your phone’s blowing up.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Nope. Not a single call.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Texts, then.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Zip. It’s the beauty of not having a phone.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘You’re kidding!’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He holds his hands out wide. ‘Search me.’ Then he adds, ‘I don’t know if it’s not having a phone, or not having friends.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Now I know you’re kidding, a guy like you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘What "), _c('em', [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("about")])]), _vm._v(" a guy like me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("She looks him up and down, appraisingly. ‘Pippa said you’re sort-of good-looking … check. A guy in his thirties … check.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Just barely.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Still. With most of his hair …’ She reaches out and trails her fingers through his mostly dark hair. ‘A few of them gray, but so what?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Now she assumes the tone of a statistician. ‘Six feet tall, one-fifty, one-fifty-five or so … you’re what we girls call a catch. Straight, no visible scars.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He smiles sheepishly. ‘They’re all on the inside.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Oh, right.’ A sympathetic expression appears on her face. ‘She said you were a widower. I’m sorry.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He says, ‘No, I didn’t mean …’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("His date puts a gentle hand on his. ‘You must miss them terribly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He moves his hand from under hers to run it through his hair. ‘Look, I’d rather not …’")]), _c('span', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "indented "
  }, [_vm._v("He stops what he’s doing and stares at the behind-the-bar TV over her shoulder. A follow-up to the Chinese moon story, it shows old NASA footage from the POV of the lunar module Eagle on its approach to the cratered surface. Something about it rivets his attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("‘Gary, I’m sorry if—’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He gets up and throws bills down on the table. ‘I gotta go.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("His date half-rises. ‘Was it something I …?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Gary isn’t listening. Army is up and ready to leave. ‘I’ll call you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("He and the dog are out the door by the time she picks up her purse.")]), _vm._v(" "), _c('p', {
    staticClass: "indented "
  }, [_vm._v("Under her breath she says, ‘Don’t bother.’")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db44a220","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781448303595_epub_chap006.vue
// module id = 93
// module chunks = 0